module.exports = __webpack_public_path__ + "img/barrage_title.4c0b42bd.png";